import {
  faCheck,
  faInfoCircle,
  faTimes
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Listbox, Transition } from "@headlessui/react";
import { ModalContext } from "@notanumber/nan-component-library";
import InputFieldGrinwis from "components/General/InputFieldGrinwis/InputFieldGrinwis";
import { ModalCustomization } from "constants/modal";
import { printHTML } from "hooks/utils/formatter";
import { Fragment, useContext } from "react";
import { twMerge } from "tailwind-merge";

const PropertyOption = ({
  label,
  options,
  inputLabel,
  setSelected,
  isCustom,
  info,
  selected,
  is_error,
}) => {
  const { setOverlay } = useContext(ModalContext);
  const has_info = info?.acf_eigenschap_informatie;

  return (
    <>
      {/* <div className="flex h-8 pt-2 md:pt-0 md:h-12 gap-2 xl:gap-0 items-center w-full flex-row lg:px-4 px-5 font-bold lg:justify-between bg-white lg:bg-body md:w-[10.5rem] xl:w-[12.5rem] rounded-t-5 md:rounded-l-5 md:rounded-r-none">
        <div className="label">{label}</div>
        {has_info && (
          <FontAwesomeIcon
            title={"Meer informatie over " + label}
            onClick={() => {
              setOverlay(
                <div>{printHTML(info?.acf_eigenschap_informatie)}</div>,
                ModalCustomization
              );
            }}
            icon={faInfoCircle}
            className={`lg:w-5 lg:h-5 h-4 w-4 text-primary transition cursor-pointer `}
            aria-hidden="true"
          />
        )}
      </div> */}
      <Listbox
        className={"mb-2 last-of-type:mb-0 md:mb-0 "}
        value={selected ||""}
        onChange={setSelected}
      >
        {({  }) => (
          <div className="relative">
            <Listbox.Button
              className={twMerge(
                "relative w-full pl-5 pr-10 text-left bg-white cursor-pointer h-12 rounded-5 focus:outline-none sm:text-sm",
                is_error && "border border-red-500"
              )}
            >
              <span
                className={twMerge(
                  "block truncate text-[#7F8D97]",
                  selected && "text-body-dark"
                )}
              >
                {selected ? (
                  <>
                    {selected?.name}{" "}
                    {isCustom && !selected?.custom && (
                      <span className="inline-flex px-2 ml-3 text-xs h-[1.125rem] text-white rounded-full bg-primary w-fit items-center justify-center">
                        standaard
                      </span>
                    )}
                  </>
                ) : (
                  inputLabel
                )}
              </span>
            </Listbox.Button>
            <span className="absolute inset-y-0 right-0 flex items-center pr-5 pointer-events-none">
              <svg
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 2L6 6L10 2"
                  stroke="#011D31"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>
            </span>
            {selected && (
              <div
                className="absolute inset-y-0 flex items-center pr-2 cursor-pointer right-6 z-5"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelected(null);
                }}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  className={`w-5 h-5 text-gray-400 transition `}
                  aria-hidden="true"
                />
              </div>
            )}

            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options
                className={twMerge(
                  "absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white shadow-lg rounded-5 max-h-60 ring-1 ring-black/5 focus:outline-none sm:text-sm"
                )}
                id="modalSelector"
              >
                {isCustom && (
                  <>
                    <div className="relative flex items-center m-4 mb-0 border space-between border-body-dark rounded-5">
                      <InputFieldGrinwis
                        value={selected?.custom ? selected?.value : ""}
                        label={`Voer hier uw gemeten ${label.toLowerCase()} in`}
                        name="length"
                        onChange={(e) => {
                          const value = e.target.value;
                          //trim input
                          if (!value) {
                            setSelected(null);
                            return;
                          }
                          const name = value.toString().trim() + " mm";

                          setSelected({ custom: true, value, name });
                        }}
                      />
                      <div className="absolute h-5 top-[0.875rem] right-4">mm</div>
                    </div>

                    <div className="flex flex-row items-center gap-[0.375rem] pt-4 pb-2">
                      <div className="flex-1 h-[0.0625rem] bg-body-dark"></div>
                      <div className="text-sm font-bold leading-none">
                        Of kies een standaard maat
                      </div>
                      <div className="flex-1 h-[0.0625rem] bg-body-dark"></div>
                    </div>
                  </>
                )}
                {options.map((option, index) => (
                  <Listbox.Option
                    key={option?.value?.term_id || "option_"+index }
                    className={({ active, selected: is_selected }) =>
                      twMerge(
                        `relative cursor-default select-none py-2 px-4 list-none h-10 flex items-center`,
                        (active || is_selected) && "bg-body",
                        option?.disabled && "opacity-50 cursor-not-allowed"
                      )
                    }
                    disabled={option?.disabled}
                    value={option}
                  >
                    {({ selected: is_selected }) => (
                      <>
                        <span
                          className={twMerge(
                            ` text-sm sm:text-15`,
                            is_selected && "font-medium"
                          )}
                        >
                          {option?.name}
                        </span>
                        {is_selected ? (
                          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                            <FontAwesomeIcon
                              icon={faCheck}
                              className="w-5 h-5"
                              aria-hidden="true"
                            />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        )}
      </Listbox>
    </>
  );
};

export default PropertyOption;
